module.exports = __webpack_public_path__ + "img/FFBC862A0DA32ABEB7BF87E14FCE06E2.ffbc862a.png";